import { render, staticRenderFns } from "./PaymentModule.vue?vue&type=template&id=1018daf4&scoped=true"
import script from "./PaymentModule.vue?vue&type=script&lang=js"
export * from "./PaymentModule.vue?vue&type=script&lang=js"
import style0 from "./PaymentModule.vue?vue&type=style&index=0&id=1018daf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1018daf4",
  null
  
)

export default component.exports